﻿import type { App } from 'vue';
import { createPinia, setActivePinia, type Pinia } from 'pinia';
import { useSofDragDropStore, type SofDragDropModule } from '../Components/SofDragDrop/sof-drag-drop-module';
import { useSummaryErrorsStore, type SummaryErrorsModule } from '../Components/SummaryErrors/summary-errors-module';
import { useSoftoolsSignalrStore, type SoftoolsSignalrModule } from "../Notifications/SignalR/softools-signalr-module";

export default class SoftoolsGlobalStore {
    private static _pinia?: Pinia;
    private static get pinia() { return window?.softools?.pinia ?? SoftoolsGlobalStore._pinia; }
    private static set pinia(newValue: Pinia | undefined) {
        if (window?.softools) {
            window.softools.pinia = newValue;
        } else {
            SoftoolsGlobalStore._pinia = newValue;
        }
    }

    static getPinia(): Pinia {
        SoftoolsGlobalStore.pinia ??= createPinia();
        setActivePinia(SoftoolsGlobalStore.pinia);
        return SoftoolsGlobalStore.pinia;
    }

    static installPinia(app: App<Element>, pinia = SoftoolsGlobalStore.getPinia()): void {
        const appWithFlag = app as App<Element> & { __softoolsPiniaInstalled?: boolean };
        if (!appWithFlag.__softoolsPiniaInstalled) {
            SoftoolsGlobalStore.pinia = pinia;
            setActivePinia(pinia);
            app.use(pinia);
            appWithFlag.__softoolsPiniaInstalled = true;
        }
    }

    /**
     * Get the SoftoolsSignalrModule.
     */
    static getSoftoolsSignalrModule(): SoftoolsSignalrModule {
        return useSoftoolsSignalrStore(SoftoolsGlobalStore.getPinia());
    }

    /**
     * Get the SummaryErrorsModule.
     */
    static getSummaryErrorsModule(): SummaryErrorsModule {
        return useSummaryErrorsStore(SoftoolsGlobalStore.getPinia());
    }

    /**
     * Get the SofDragDropModule.
     */
    static getSofDragDropModule(): SofDragDropModule {
        return useSofDragDropStore(SoftoolsGlobalStore.getPinia());
    }

}
